<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!--            <a-col :md="8" :sm="24">-->
            <!--              <a-form-item label="手机号" prop="mobile">-->
            <!--                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.bizUser.query.email')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('views.bizUser.query.emailPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.bizUser.query.nickname')" prop="nickname">
                <a-input v-model="queryParam.nickname" :placeholder="$t('views.bizUser.query.nicknamePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.bizUser.query.isVip')" prop="isVip">
                <a-select :placeholder="$t('views.bizUser.query.isVipPlaceholder')" v-model="queryParam.isVip" style="width: 100%" allow-clear>
                  <a-select-option v-for="item in isVipOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.bizUser.query.paymentMethod')" prop="paymentMethod">
                <a-select :placeholder="$t('views.bizUser.query.paymentMethodPlaceholder')" v-model="queryParam.paymentMethod" style="width: 100%" allow-clear>
                  <a-select-option v-for="item in paymentMethodOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.bizUser.query.userStatus')" prop="status">
                <a-select :placeholder="$t('views.bizUser.query.userStatusPlaceholder')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in dict.type.sys_enable_disable" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="邀请码" prop="invitationCode">-->
<!--                  <a-input v-model="queryParam.invitationCode" placeholder="请输入邀请码" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否推送" prop="isNotice">-->
<!--                  <a-select placeholder="请选择是否推送" v-model="queryParam.isNotice" style="width: 100%" allow-clear>-->
<!--                    <a-select-option v-for="(d, index) in dict.type.sys_notice_status" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
<!--                  </a-select>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.bizUser.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.bizUser.btn.reset') }}</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createAccountForm.handleAdd()" v-hasPermi="['biz:user:add']">
          <a-icon type="plus" />{{ $t('views.bizUser.btn.createAccount') }}
        </a-button>
        <table-setting
          :key="$i18n.locale"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
          style="margin-bottom: 20px;" />
      </div>
      <!-- 创建账号 -->
      <create-account-form
        ref="createAccountForm"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <reset-password ref="resetPassword" />
      <vip-payment-edit ref="vipPaymentEdit" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :scroll="{x:true}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
<!--        <span slot="sex" slot-scope="text, record">-->
<!--          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>-->
<!--        </span>-->

        <!--        <span slot="status" slot-scope="text, record">-->
        <!--          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>-->
        <!--        </span>-->

        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            :disabled="!canEdit"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-space class="user-op-actions" :size="12">
            <a v-hasPermi="['biz:user:resetPassword']" @click="$refs.resetPassword.handleResetPwd(record)">
              <a-icon type="edit" />{{ $t('views.bizUser.action.resetPassword') }}
            </a>
            <a v-hasPermi="['biz:user:updateVipPayment']" @click="$refs.vipPaymentEdit.show(record)">
              <a-icon type="edit" />{{ $t('views.bizUser.action.editVipPayment') }}
            </a>
          </a-space>
<!--          <a-divider type="vertical" />-->
<!--          <a @click="$refs.createForm.handleUpdate(record)" >-->
<!--            <a-icon type="plus" />充值余额-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, delUser, updateUserStatus } from '@/api/biz/user'
import CreateAccountForm from './modules/CreateAccountForm'
import { tableMixin } from '@/store/table-mixin'
import auth from '@/plugins/auth'
import ResetPassword from './modules/ResetPassword'
import VipPaymentEdit from './modules/VipPaymentEdit'
export default {
  name: 'User',
  components: {
    CreateAccountForm,
    ResetPassword,
    VipPaymentEdit
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      columns: [],
      // 查询参数
      queryParam: {
        email: null,
        nickname: null,
        isVip: undefined,
        paymentMethod: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  filters: {
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  computed: {
    isVipOptions () {
      return [
        { value: 0, label: this.$t('views.bizUser.option.notPro') },
        { value: 1, label: this.$t('views.bizUser.option.pro') }
      ]
    },
    paymentMethodOptions () {
      return [
        { value: 0, label: this.$t('views.bizUser.option.paymentFull') },
        { value: 1, label: this.$t('views.bizUser.option.paymentFirst') },
        { value: 2, label: this.$t('views.bizUser.option.paymentMonthly') }
      ]
    },
    canEdit () {
      return auth.hasPermi('biz:user:edit')
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    paginationShowTotal (total) {
      return this.$t('views.bizUser.pagination.total', { total })
    },
    buildColumns () {
      const dash = this.$t('views.bizUser.cell.dash')
      this.columns = [
        {
          title: this.$t('views.bizUser.column.id'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('views.bizUser.column.email'),
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.bizUser.column.nickname'),
          dataIndex: 'nickname',
          align: 'center'
        },
        {
          title: this.$t('views.bizUser.column.isVip'),
          dataIndex: 'isVip',
          align: 'center',
          customRender: (t, r) => {
            const v = r && r.isVip
            if (v === 1) return this.$t('views.bizUser.option.pro')
            if (v === 0) return this.$t('views.bizUser.option.notPro')
            return dash
          }
        },
        {
          title: this.$t('views.bizUser.column.paymentMethod'),
          dataIndex: 'paymentMethod',
          align: 'center',
          customRender: (t, r) => {
            const v = r && r.paymentMethod
            if (v === 0) return this.$t('views.bizUser.option.paymentFull')
            if (v === 1) return this.$t('views.bizUser.option.paymentFirst')
            if (v === 2) return this.$t('views.bizUser.option.paymentMonthly')
            return dash
          }
        },
        {
          title: this.$t('views.bizUser.column.firstRate'),
          dataIndex: 'firstModelRate',
          align: 'center',
          customRender: (t, r) => {
            const pm = r && r.paymentMethod
            if (pm !== 1) return dash
            const v = r && r.firstModelRate
            if (v === undefined || v === null || v === '') return dash
            return v
          }
        },
        {
          title: this.$t('views.bizUser.column.userStatus'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('views.bizUser.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('views.bizUser.column.operation'),
          dataIndex: 'operation',
          width: 240,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    openXinde(record) {
      this.$refs.cityArticleForm.show({
        userId: record.id,
        id: null,
        type: 1
      })
    },
    /** 用户状态开关（需 biz:user:edit，与产品分类页一致） */
    handleStatusChange (record, checked) {
      if (!this.canEdit) {
        return
      }
      const statusValue = checked ? 1 : 0
      const oldStatus = record.status
      record.status = statusValue
      updateUserStatus({ id: record.id, status: statusValue }).then(() => {
        this.$message.success(this.$t('views.bizUser.msg.operationSuccess'))
      }).catch(() => {
        record.status = oldStatus
        this.$message.error(this.$t('views.bizUser.msg.statusFail'))
      })
    },
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
     pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        email: undefined,
        nickname: undefined,
        isVip: undefined,
        paymentMethod: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: that.$t('views.bizUser.confirm.deleteTitle'),
        content: that.$t('views.bizUser.confirm.deleteContent', { ids }),
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.bizUser.msg.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: that.$t('views.bizUser.confirm.exportTitle'),
        content: that.$t('views.bizUser.confirm.exportContent'),
        onOk () {
          that.download('biz/user/export', {
            ...that.queryParam
          }, that.$t('views.bizUser.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
.user-op-actions {
  white-space: nowrap;
}
</style>
